import { FeatureFlag } from '../FeatureFlag';

export const useWidgetTabIdForUserViewKey = new FeatureFlag({
    key: 'use-widget-tab-id-for-user-view-key',
    createdOn: '2025-07-09',
    defaultValue: false,
});
